import React, { useEffect, useState } from "react"
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from "react-redux"
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'
import FilterSearch from 'pages/parts/FilterSearch'
import { PGET, GET, POST } from 'helpers/api'
import { formatMoney, returnSign, formatDateBackend, findFromArrayById, formatDate, formatDateWithTime, formatMoneyInput } from 'helpers/helpers'
import Pagination, { ItemPerPage } from "pages/parts/Pagination"
import { CloseOutlined, MonetizationOnOutlined } from "@material-ui/icons"

function Index() {

	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)
	const [showExpensesModal, setShowExpensesModal] = useState(false);
	const [debtorOut, setDebtorOut] = useState({})
	const [expenses, setExpenses] = useState([]);
	const date = new Date()
	const [poses, setPoses] = useState([])
	const [paymentTypes, setPaymentTypes] = useState([])
	const [cashiers, setCashiers] = useState([])
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [totalAmount, setTotalAmont] = useState([])
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [ItemsPerPage, setItemsPerPage] = useState(20)
	const [URL, setURL] = useState("");
	const [pageCount, setPageCount] = useState(0)

	const [filterData, setFilterData] = useState({
		startDate: formatDateBackend(new Date(date.getFullYear(), date.getMonth(), 1)),
		endDate: formatDateBackend(new Date()),
		posId: reduxAccount.posId,
		cashierId: null,
		clientId: null,
		paymentPurposeId: null,
		search: '',
	})
	const [pagination, setPagination] = useState({
		url: '/services/web/api/report-expense',
		response: null
	})
	const [data, setData] = useState([])

	async function searchWithFilter(exportToExcel = false, tableSort = "") {
		var filterUrl = "/services/web/api/report-expense"
		var urlParams = ""
		checkFilter()

		if (filterData.posId)
			urlParams += returnSign(urlParams) + 'posId=' + filterData.posId
		if (filterData.cashierId)
			urlParams += returnSign(urlParams) + 'cashierId=' + filterData.cashierId
		if (filterData.paymentPurposeId)
			urlParams += returnSign(urlParams) + 'paymentPurposeId=' + filterData.paymentPurposeId
		if (filterData.clientId)
			urlParams += returnSign(urlParams) + 'clientId=' + filterData.clientId
		if (filterData.startDate)
			urlParams += returnSign(urlParams) + 'startDate=' + filterData.startDate
		if (filterData.endDate)
			urlParams += returnSign(urlParams) + 'endDate=' + filterData.endDate
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search

		if ("/services/web/api/report-expense" + urlParams !== filterUrl && !exportToExcel)
			setFilterDataExist(true)

		if (tableSort) {
			var filterDataCopy = { ...filterData }
			if (filterDataCopy.tableSortKey === tableSort) {
				filterDataCopy.tableSortDirection === ',asc' ? filterDataCopy.tableSortDirection = ',desc' : filterDataCopy.tableSortDirection = ',asc'
			} else {
				filterDataCopy.tableSortDirection = ',asc'
			}
			filterDataCopy.tableSortKey = tableSort

			setFilterData(filterDataCopy)
			urlParams += returnSign(urlParams) + 'sort=' + tableSort + filterDataCopy.tableSortDirection
		}
		let WithoutParams = filterUrl
		filterUrl = filterUrl + urlParams
		setURL(filterUrl);

		if (exportToExcel) {
			filterUrl = "/services/web/api/report-expense-excel" + urlParams + returnSign(filterUrl)

			var excelHeaders = [[t('POS'), t('CASHBOX'), t('CASHIER'), t('EXPENSE_TYPE'), t('PAYMENT_TYPE'),
			t('NOTE'), t('EXPENSE_AMOUNT'), t('DATE')]]
			const response = await GET(filterUrl)
			for (let i = 0; i < response?.length; i++) {
				var excelItems = []
				excelItems.push(response[i].posName)
				excelItems.push(response[i].cashboxName)
				excelItems.push(response[i].cashierName)
				excelItems.push(response[i].paymentPurposeName)
				excelItems.push(response[i].paymentTypeName)
				excelItems.push(response[i].note)
				excelItems.push(response[i].amountOut)
				excelItems.push(formatDate(response[i].createdDate))
				excelHeaders.push(excelItems)
			}
			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			styleExcelSheet(ws)
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('EXPENSE_REPORT') + ".xlsx");
		} else {
			const response = await PGET(WithoutParams, { ...filterData, size: ItemsPerPage }, { loader: true })
			if (response) {
				setData(response.data)
				setPagination({ ...pagination, 'url': filterUrl, 'response': response })
				setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))

			}
			filterUrl = "/services/web/api/report-expense-total/" + urlParams
			const temporaryTotalAmount = await GET(filterUrl)
			setTotalAmont(temporaryTotalAmount)
		}

		setDropdownIsOpen(false)
	}


	function resetFilter() {
		setFilterData({
			startDate: null,
			endDate: null,
			posId: null,
			cashierId: null,
			clientId: null,
			paymentPurposeId: null,
			search: '',
		})
		setFilterDataExist(false)
		getData()
	}

	async function getData() {
		const response = await PGET("/services/web/api/report-expense", { ...filterData, size: ItemsPerPage }, { loader: true })
		if (response) {
			setData(response.data)
			setPagination({ ...pagination, 'url': "/services/web/api/report-expense", 'response': response })
			setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))

		}
		const response2 = await GET("/services/web/api/report-expense-total", {}, { loader: false })
		if (response2) {
			setTotalAmont(response2)
		}
	}

	function checkFilter() {
		if (
			filterData.startDate === null &&
			filterData.endDate === null &&
			filterData.posId === null &&
			filterData.cashierId === null &&
			filterData.clientId === null &&
			filterData.paymentPurposeId === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleExpenseModal(bool = false) {
		if (bool) {
			GET("/services/web/api/expense-helper").then(response => {
				// setExpenses(response)
				var expenseId = 0
				if (response?.length > 0) expenseId = response[0]['id']
				setDebtorOut({ ...debtorOut, "expenseId": expenseId, "amountOut": "", "note": "" })
			});
			setShowExpensesModal(true)
		} else {
			setShowExpensesModal(false)
		}
	}

	function createDebtorOut(e) {
		e.preventDefault();
		POST("/services/web/api/expense-out", debtorOut).then(() => {
			setDebtorOut({ ...debtorOut, "expenseId": "", "amountOut": "", "note": "" })
			setShowExpensesModal(false)
		});
	}

	function closeExpensesModal() {
		setShowExpensesModal(false)
		setDebtorOut({ ...debtorOut, "amountOut": "" })
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) {
			response.unshift({ 'id': null, 'name': t('ALL') })
			setPoses(response)
		}
	}

	async function getCashiers() {
		const response = await GET('/services/web/api/cashier-helper')
		if (response) {
			setCashiers(response)
		}
	}

	async function getExpensesHelper() {
		const response = await GET('/services/web/api/expense-helper')
		if (response) {
			const updatedList = [
				{ id: null, name: t('ALL') },
				...response
			]
			setPaymentTypes(updatedList)
		}
	}


	async function paginate(data) {
		const response = await PGET(URL, { ...filterData, page: data.selected, size: ItemsPerPage }, { loader: true })
		setFilterData({ ...filterData, page: data.selected })
		setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
		setData(response.data);
	}


	useEffect(() => {
		getPoses()
		getCashiers()
		getExpensesHelper()
	}, [ItemsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter(false)
	}, [filterData.search, ItemsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('EXPENSE_REPORT')}
				</h4>
				{/* <div className="d-flex">
					<Link className="btn-rounded btn btn-primary" onClick={() => toggleExpenseModal(true)}>
						<i className="uil uil-plus me-2"></i>
						{t('CREATE')}
					</Link>
				</div> */}
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}
									disableGroupSearch>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 me-2">
										{t('FILTER')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('POS')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.posId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'posId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('CASHIER')}</label>
												<Select
													options={cashiers}
													value={cashiers.find(option => option.id === filterData.cashierId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'cashierId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('EXPENSE_TYPE')}</label>
												<Select
													options={paymentTypes}
													value={paymentTypes.find(option => option.id === filterData.paymentPurposeId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'paymentPurposeId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('PERIOD')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.startDate ? new Date(filterData.startDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'startDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.endDate ? new Date(filterData.endDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'endDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('CANCEL')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('APPLY')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide" onClick={() => searchWithFilter(true)}>EXCEL</button>
							</div>

						</div>
						<div className="d-flex">
							<div className="vertical-center me-2">
								<h4>
									<b>{t('TOTAL_AMOUNT')}</b>:
								</h4>
							</div>
							<div className="vertical-center">
								{totalAmount?.map((item, index) => (
									<h5 className="text-end" key={index}>
										<span className="me-1">{formatMoney(item.totalAmount)}</span>
										<b>{item.currencyName}</b>
										{item.paymentTypeName &&
											<span className="ms-1 text-muted">({item.paymentTypeName})</span>
										}
									</h5>
								))
								}
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('FILTER')}</strong>
								<br />
								{(filterData.startDate || filterData.endDate) &&
									<span className="me-2">
										<b>{t('PERIOD')}: </b>
										{filterData.startDate &&
											<span>{formatDate(filterData.startDate)}</span>
										}
										{(filterData.startDate && filterData.endDate) &&
											<span>|</span>
										}
										{filterData.endDate &&
											<span>{formatDate(filterData.endDate)}</span>
										}
									</span>
								}
								{filterData.posId &&
									<span className="me-2">
										<b>{t('POS')}: </b> {findFromArrayById(poses, filterData.posId)}
									</span>
								}
								{filterData.cashierId &&
									<span className="me-2">
										<b>{t('CASHIER')}: </b> {findFromArrayById(cashiers, filterData.cashierId)}
									</span>
								}
								{filterData.paymentPurposeId &&
									<span className="me-2">
										<b>{t('TYPE')}: </b> {findFromArrayById(paymentTypes, filterData.paymentPurposeId)}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('SEARCH')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('RESET')}</button>
							</div>
						</div>
					}

					<ItemPerPage
						itemsPerPage={ItemsPerPage}
						setItemsPerPage={(e) => {
							setItemsPerPage(e); // Update ItemsPerPage
							setFilterData({ ...filterData, page: 0, random: filterData.random + 1 }); // Reset to the first page

						}}
					/>

					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th className="th-sortable cursor" onClick={() => searchWithFilter(false, 'posName')}>
										{t('POS')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'posName') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'posName') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor" onClick={() => searchWithFilter(false, 'cashboxName')}>
										{t('CASHBOX')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'cashboxName') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'cashboxName') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'cashierName')}>
										{t('CASHIER')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'cashierName') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'cashierName') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'paymentPurposeName')}>
										{t('EXPENSE_TYPE')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'paymentPurposeName') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'paymentPurposeName') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'paymentTypeName')}>
										{t('PAYMENT_TYPE')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'paymentTypeName') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'paymentTypeName') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'note')}>
										{t('NOTE')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'note') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'note') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'amountOut')}>
										{t('EXPENSE_AMOUNT')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'amountOut') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'amountOut') && 'sort-active')}></i>
										</div>
									</th>
									<th className="th-sortable cursor text-center" onClick={() => searchWithFilter(false, 'createdDate')}>
										{t('DATE')}
										<div className="table-sort">
											<i className={'uil uil-angle-up ' + ((filterData.tableSortDirection === ',asc' && filterData.tableSortKey === 'createdDate') && 'sort-active')}></i>
											<i className={'uil uil-angle-down ' + ((filterData.tableSortDirection === ',desc' && filterData.tableSortKey === 'createdDate') && 'sort-active')}></i>
										</div>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td>{item.rowNum}. {item.posName}</td>
										<td>{item.cashboxName}</td>
										<td className="text-center">{item.cashierName}</td>
										<td className="text-center">{item.paymentPurposeName}</td>
										<td className="text-center">{item.paymentTypeName}</td>
										<td className="text-center">{item.note}</td>
										<td className="text-center">{formatMoney(item.amountOut)} {item.currencyName}</td>
										<td className="text-center">{formatDateWithTime(item.createdDate)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate} reduxPage={filterData.page}></Pagination>

				</div>

				<Modal
					show={showExpensesModal}
					animation={false}
					centered
					onHide={() => closeExpensesModal()}
					dialogClassName="update-modal-width" backdrop="static"
				>
					<Modal.Body>
						<Modal.Header closeButton>
						</Modal.Header>

						<form onSubmit={(e) => createDebtorOut(e)} className="w-100">
							<div className="form-group">
								<label className="color-a2">{t("EXPENSE_TYPE")}</label>
								<select
									className="form-select"
									value={debtorOut.expenseId ?? ''}
									onChange={(e) =>
										setDebtorOut({ ...debtorOut, expenseId: Number(e.target.value) || null })
									}
								>
									{paymentTypes.slice(1).map((item) => (   // <-- skip the first item
										<option value={item.id} key={item.id}>
											{item.name}
										</option>
									))}
								</select>
							</div>

							<div className="form-group position-relative">
								<label className="color-a2">
									{/* {t("cash")} ({cashbox.defaultCurrency === 2 ? "USD" : t("sum")}) */}
									{t("EXPENSE_AMOUNT")}
								</label>
								<input
									type="text"
									placeholder={
										formatMoney(0)
										// " " +
										// (cashbox.defaultCurrency === 2 ? "USD" : t("sum"))
									}
									className="custom-input"
									value={
										debtorOut.amountOut
											? formatMoneyInput(debtorOut.amountOut)
											: ""
									}
									onChange={(e) =>
										setDebtorOut({
											...debtorOut,
											amountOut: e.target.value.replace(/[^0-9.]/g, ""),
										})
									}
								/>
								<span className="input-inner-icon">
									{/* <img src={money} width={25} alt="money" /> */}
								</span>
							</div>
							<div className="form-group">
								<label className="color-a2 text-uppercase">{t("NOTE")}</label>
								<input
									className="custom-input "
									placeholder={t("NOTE")}
									rows={2}
									onChange={(e) =>
										setDebtorOut({ ...debtorOut, note: e.target.value })
									}
								/>
							</div>
							<button
								type="submit"
								className="btn btn-primary w-100"
							// disabled={debtorOut?.amountOut?.length === 0}
							>
								{t("ACCEPT")}
							</button>
						</form>
					</Modal.Body>
				</Modal>
			</div>
		</>
	)
}

export default Index
